<template>
  <div class="mb-3 row">
    <div class="col">
      <div class="bg-100 shadow-none border card">
        <div class="flex-between-center row gx-0">
          <div class="d-flex align-items-center col-sm-auto">
            <div>
              <h5 class="mb-0 p-3 text-primary fw-bold">
                데이터 검색 <span class="text-info fw-medium">디바이스 와 기간을 설정</span>
              </h5>
            </div>
          </div>
          <div class="p-3 col-md">
            <DeviceSelect
              v-if="user"
              v-model:device="selectDevice"
              v-model:start="startDate"
              v-model:end="endDate"
              :user="user"
              :settype="settype"
              @search="handleSerach"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="h-100 card">
    <div class="d-flex flex-between-center py-2 border-200 border-bottom card-header">
      <h6 class="mb-0">
        검색 결과
      </h6>
    </div>
    <div class="d-flex align-items-center card-body">
      <div class="w-100">
        <CommGrid
          :rows="loadResults"
          :columns="columnDefs"
          :is-check-box="false"
          :set-grid-height="null"
          :use-pagination="true"
          :per-page="20"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import moment from 'moment'
import DeviceSelect from '../components/DeviceSelect.vue'
import CommGrid from '../components/CommGrid.vue'
import axios from 'axios'
import type { ColumnDefinition, Device, SearchResult } from '@/types/commontypes'


const loadResults = ref<SearchResult[]>([]);

// type ColumnDef = { field: string; label: string; thClass?: string; tdClass?: string; width?: string };
const columnDefs = ref<ColumnDefinition[]>([]);

const user = ref(null)
const settype = ref<string | ''>('')
const selectDevice = ref<Device | null>(null)
const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)


interface SearchInfo {
  strfrom: string;
  strto: string;
}

const gcurrentSearchInfo:SearchInfo = {
    strfrom: '',
    strto: ''
};

onMounted(async () =>{
    settype.value = 'search';
    const res = await axios.get('/api/userinfo', { withCredentials: true });
    user.value = res.data.user;
});


/**
 * DeviceSelect 컴포넌트에서 search 이벤트
 */
function handleSerach() {
     LoadSDataList(1)
}

function LoadSDataList(searchtype:number) {
    const deviceobj = selectDevice.value;
    const strStart = moment(startDate.value).format('YYYY-MM-DDTHH:mm:ss')
    const strEnd = moment(endDate.value).format('YYYY-MM-DDT23:59:59')

    gcurrentSearchInfo.strfrom = strStart;
    gcurrentSearchInfo.strto = strEnd;
  
    getColumnInfo();
    LoadGridData(deviceobj, searchtype);
}

function LoadGridData(deviceobj:Device | null, _searchtype:number) {
    if(!deviceobj) return;

    const data = JSON.stringify({ 
        'operator': "getSDatalist", 
        'deviceid' : deviceobj.deviceid,
        'from' : gcurrentSearchInfo.strfrom,
        'to' : gcurrentSearchInfo.strto
    });
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		const result : SearchResult[] = JSON.parse(xhr.responseText);

        // 값이 없는 필드를 '-'로 변환
        const formattedResult = result.map(row => {
            const formattedRow: SearchResult = {regdt: row.regdt};
            for (const key in row) {
                // const value = row[key as keyof SearchResult];
                const value = row[key]
                // null, undefined, 빈 문자열을 '-'로 변환
                formattedRow[key] = (value === null || value === undefined || value === '') ? '-' : value;
            }
            return formattedRow;
        });

        loadResults.value = [...formattedResult];
    });
}

// 조회결과를 표시할 그리드의 컬럼정보를 구성함
function getColumnInfo() {
    const deviceobj = selectDevice.value;
    if(!deviceobj)
        return;

    columnDefs.value = [];

    // 시간 컬럼: 헤더와 데이터 모두 가운데 정렬
    const adddef = {
        field: 'regdt',
        label: '시간',
        thClass: 'text-center',  // 헤더 가운데 정렬
        tdClass: 'text-center',  // 데이터 가운데 정렬
        width: '10%'
    };
    columnDefs.value.push(adddef);

    const svlistjson = JSON.parse(deviceobj.svlist);
    // console.log("getColumn svlistjson : ", svlistjson)
    for(const si in svlistjson) {
        const dfkey = svlistjson[si].dfkey;
        const sname = svlistjson[si].sname;

        // 센서 데이터 컬럼: 헤더는 가운데, 데이터는 오른쪽 정렬 (숫자)
        const cDef: ColumnDefinition = {
            field: String(dfkey),
            label: String(sname),
            thClass: 'text-center',  // 헤더 가운데 정렬
            tdClass: 'text-center'    // 데이터 오른쪽 정렬 (숫자이므로)
        };
        columnDefs.value.push(cDef);
    }

    console.log('columnDefs ---------------- ', selectDevice.value, columnDefs)
}

</script>

<style scoped>
/* 필요 시 스타일 추가 */
</style>